import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API } from "../service/Interceptor";
import {
  getAllPostsAPI,
  followUserAPI,
  unfollowUserAPI,
} from "../service/apiUrl";

const initialState = {
  posts: [],
  post: null,
  userPosts: [],
  isPostsLoading: false,
  hasError: false,
};

export const createPost = createAsyncThunk("create-post", async (payload) => {
  try {
    const res = await API.post("api/post", payload);

    // console.log("Create post response:", res.data.success);

    return res?.data?.success;
  } catch (error) {
    console.log(error);
  }
});

// export const getAllPosts = createAsyncThunk("get-all-posts", async (params) => {
//   try {
//     const res = await API.get(getAllPostsAPI, { params });

//     return {
//       posts: res?.data?.data?.results || [],
//       id: params?.postOwnerId,
//       tags: params?.tags,
//       pageNo: params?.pageNo,
//     };
//   } catch (error) {
//     console.log(error);
//   }
// });

export const getAllPosts = createAsyncThunk(
  "get-all-posts",
  async (params, { rejectWithValue }) => {
    try {
      const res = await API.get(getAllPostsAPI, { params });
      const posts = res?.data?.data?.results || [];

      if (res?.data?.success) {
        return {
          posts,
          id: params?.postOwnerId,
          tags: params?.tags,
          pageNo: params?.pageNo,
        };
      }

      return rejectWithValue(res?.data?.message || "No posts found");
    } catch (error) {
      return rejectWithValue(
        error.message || "Unexpected error fetching posts",
      );
    }
  },
);

export const getPostById = createAsyncThunk(
  "get-post-by-id",
  async (postId, { rejectWithValue }) => {
    try {
      const res = await API.get(`api/post/${postId}`);
      const post = res?.data?.data;

      if (res?.data?.success && post) {
        return { post };
      }

      return rejectWithValue(res?.data?.message || "Post not found");
    } catch (error) {
      return rejectWithValue(error.message || "Unexpected error");
    }
  },
);

export const likeAPost = createAsyncThunk(
  "like-a-post",
  async (id, { getState }) => {
    try {
      const { data } = await API.post(`api/post/${id}/like`);

      if (data?.success) {
        return {
          id,
          totalLikes: data?.data?.totalLikes,
          liked: data?.data?.liked,
        };
      }
    } catch (error) {
      console.log(error);
    }
  },
);

export const unlikeAPost = createAsyncThunk(
  "unlike-a-post",
  async (id, { getState }) => {
    try {
      const { data } = await API.delete(`api/post/${id}/unlike`);

      if (data?.success) {
        return { id };
      }
    } catch (error) {
      console.log(error);
    }
  },
);

export const commentAPost = createAsyncThunk(
  "comment-a-post",
  async (payload) => {
    try {
      const { data } = await API.post(`api/post/${payload?.id}/comment`, {
        comment: payload?.comment,
        parentId: payload?.parentId,
      });
      return { id: payload?.id, commentCount: data?.data?.totalComments };
    } catch (error) {
      console.log(error);
    }
  },
);

export const getPostComments = createAsyncThunk(
  "get-post-comment",
  async ({ id }) => {
    try {
      const res = await API.get(`api/post/${id}/comment`);
      return { id, comments: res?.data?.data?.results };
    } catch (error) {
      console.log(error);
    }
  },
);

export const deleteAComment = createAsyncThunk(
  "delete-post-comment",
  async ({ postId, commentId }) => {
    try {
      const res = await API.delete(
        `api/post/${postId}/comment/${commentId}/me`,
      );
      if (res?.data?.success) {
        return { postId, commentId };
      }
    } catch (error) {
      console.error("Delete comment error:", error);
      throw error;
    }
  },
);

export const deletePost = createAsyncThunk("delete-post", async (id) => {
  try {
    const res = await API.delete(`api/post/${id}`);

    if (res?.data?.success) {
      return { id };
    }
  } catch (error) {
    console.error("Delete post error:", error);
    throw error;
  }
});
export const followUserPost = createAsyncThunk(
  "follow-user-post",
  async ({ payload, postId }, thunkAPI) => {
    try {
      const res = await API.post(followUserAPI, payload);
      if (res?.data?.success) {
        // toast.success(res?.data?.message || "User followed");
        return { res: res?.data?.data, postId };
      }
    } catch (error) {
      console.log("Error in following an user", error);
      return thunkAPI.rejectWithValue("Something went wrong");
    }
  },
);

export const unfollowUserPost = createAsyncThunk(
  "unfollow-user-post",
  async ({ payload, postId }, thunkAPI) => {
    try {
      const res = await API.post(unfollowUserAPI, payload);
      if (res.data.success) {
        // toast.success(res?.data?.message || "User unfollowed");
        return { res: res?.data?.data, postId };
      }
    } catch (error) {
      console.log("Error in unfollowing an user", error);
      return thunkAPI.rejectWithValue("Something went wrong");
    }
  },
);

export const postsSlice = createSlice({
  name: "posts",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      //--------------------------------------------------
      // ------------------GET ALL POSTS------------------
      //--------------------------------------------------
      .addCase(getAllPosts.pending, (state, action) => {
        state.isPostsLoading = true;
        state.hasError = false;
      })
      .addCase(getAllPosts.rejected, (state, action) => {
        state.isPostsLoading = false;
        state.hasError = true;
      })
      .addCase(getAllPosts.fulfilled, (state, action) => {
        state.isPostsLoading = false;
        state.hasError = false;

        const { posts, id, tags, pageNo } = action.payload;

        if (id) {
          state.userPosts = posts;
        } else {
          if (tags !== "ALL") {
            if (pageNo === 1) {
              state.posts = posts;
            } else {
              state.posts = [...state.posts, ...posts];
            }
          } else {
            state.posts = [...state.posts, ...posts];
          }
        }
      })

      //--------------------------------------------------
      // ------------------GET POST BY ID-----------------
      //--------------------------------------------------
      .addCase(getPostById.fulfilled, (state, action) => {
        state.post = action.payload?.post;
      })

      //--------------------------------------------------
      // ------------------LIKE A POST--------------------
      //--------------------------------------------------

      .addCase(likeAPost.fulfilled, (state, action) => {
        // SINGLE POST
        if (state.post) {
          state.post.likeCount = action.payload?.totalLikes;
          state.post.isLiked = true;
        }

        // FEED
        const postIndex = state.posts.findIndex(
          (row) => row.id === action.payload?.id,
        );

        if (postIndex !== -1 && state.posts) {
          state.posts[postIndex].likeCount = action.payload?.totalLikes;
          state.posts[postIndex].isLiked = true;
        }

        // USER PROFILE
        const userPostIndex = state.userPosts.findIndex(
          (row) => row.id === action.payload?.id,
        );
        if (userPostIndex !== -1 && state.userPosts) {
          state.userPosts[userPostIndex].likeCount = action.payload?.totalLikes;
          state.userPosts[userPostIndex].isLiked = true;
        }
      })
      //--------------------------------------------------
      // ------------------DISLIKE A POST-----------------
      //--------------------------------------------------
      .addCase(unlikeAPost.fulfilled, (state, action) => {
        //SINGLE POST
        if (state.post) {
          state.post.likeCount--;
          state.post.isLiked = false;
        }

        // FEED
        const postIndex = state.posts.findIndex(
          (row) => row.id === action.payload?.id,
        );

        if (postIndex !== -1 && state.posts) {
          state.posts[postIndex].likeCount--;
          state.posts[postIndex].isLiked = false;
        }

        // USER PROFILE
        const userPostIndex = state.userPosts.findIndex(
          (row) => row.id === action.payload?.id,
        );
        if (userPostIndex !== -1 && state.userPosts) {
          state.userPosts[userPostIndex].likeCount--;
          state.userPosts[userPostIndex].isLiked = false;
        }
      })
      //--------------------------------------------------
      //--------------------POST A COMMENT----------------
      //--------------------------------------------------
      .addCase(commentAPost.fulfilled, (state, action) => {
        const { id, commentCount } = action.payload || {};

        // Helper to update count
        const updateCount = (post) => {
          if (commentCount && commentCount > 0) {
            post.commentCount = commentCount;
          } else {
            post.commentCount = (post.commentCount || 0) + 1;
          }
        };

        //SINGLE POST
        if (state.post && state.post.id === id) {
          updateCount(state.post);
        }

        //FEED
        const index = state.posts.findIndex((row) => row.id === id);
        if (state.posts && index !== -1) {
          updateCount(state.posts[index]);
        }

        //USER PROFILE
        const userPostIndex = state.userPosts.findIndex((row) => row.id === id);

        if (state.userPosts && userPostIndex !== -1) {
          updateCount(state.userPosts[userPostIndex]);
        }
      }) //--------------------------------------------------
      //----------------------- GET A COMMENT-------------
      //--------------------------------------------------
      .addCase(getPostComments.fulfilled, (state, action) => {
        const { id } = action.payload || {};
        //SINGLE POST
        if (state.post) {
          state.post.comments = action.payload?.comments;
        }

        //FEED
        const index = state.posts.findIndex(
          (row) => row.id === action.payload?.id,
        );

        if (state.posts && index !== -1) {
          state.posts[index].comments = action.payload?.comments;
        }

        //USER PROFILE
        const userPostIndex = state.userPosts.findIndex(
          (row) => row.id === action.payload?.id,
        );

        if (state.userPosts && userPostIndex !== -1) {
          state.userPosts[userPostIndex].comments = action.payload?.comments;
        }
      })
      //--------------------------------------------------
      //-----------------------DELETE A COMMENT-----------
      //--------------------------------------------------
      .addCase(deleteAComment.fulfilled, (state, action) => {
        const { postId, commentId } = action.payload || {};

        const postObject = state.posts?.find((post) => post.id === postId);

        if (!postObject) return;

        const commentObj = postObject.comments?.find(
          (comment) => comment.id === commentId,
        );

        const replyCount = commentObj?.reply?.length || 0;

        if (postObject.commentCount > 0) {
          postObject.commentCount = Math.max(
            0,
            postObject.commentCount - (replyCount + 1),
          );
        }

        //User posts
        if (state.userPosts) {
          const userPostObject = state.userPosts.find(
            (post) => post.id === postId,
          );

          if (!userPostObject) return;

          const userCommentObj = userPostObject.comments?.find(
            (comment) => comment.id === commentId,
          );

          const replyCount = userCommentObj?.reply?.length || 0;

          if (userPostObject.commentCount > 0) {
            userPostObject.commentCount = Math.max(
              0,
              userPostObject.commentCount - (replyCount + 1),
            );
          }
        }
      })
      //--------------------------------------------------
      //-----------------------FOLLOW A USER--------------
      //--------------------------------------------------
      .addCase(followUserPost.fulfilled, (state, action) => {
        //SINGLE POST
        if (state.post) {
          state.post.isFollowed = true;
        }

        //FEED
        const postIndex = state.posts.findIndex(
          (post) => post.id === action.payload.postId,
        );

        if (postIndex !== -1) {
          state.posts[postIndex].isFollowed = true;
        }

        //USER PROFILE
        const userPostIndex = state.userPosts.findIndex(
          (post) => post.id === action.payload.postId,
        );
        if (userPostIndex !== -1) {
          state.userPosts[userPostIndex].isFollowed = true;
        }
      })
      //--------------------------------------------------
      //-----------------------UNFOLLOW A USER------------
      //--------------------------------------------------
      .addCase(unfollowUserPost.fulfilled, (state, action) => {
        // SINGLE POST
        if (state.post) {
          state.post.isFollowed = false;
        }

        // FEED
        const postIndex = state.posts.findIndex(
          (post) => post.id === action.payload.postId,
        );

        if (postIndex !== -1) {
          state.posts[postIndex].isFollowed = false;
        }

        // USER PROFILE
        const userPostIndex = state.userPosts.findIndex(
          (post) => post.id === action.payload.postId,
        );

        if (userPostIndex !== -1) {
          state.userPosts[userPostIndex].isFollowed = false;
        }
      })

      //--------------------------------------------------
      //-----------------------DELETE A POST--------------
      //--------------------------------------------------
      .addCase(deletePost.fulfilled, (state, action) => {
        // FEED

        if (state.posts) {
          state.posts = state.posts.filter(
            (post) => post?.id !== action.payload?.id,
          );
        }

        // USER PROFILE
        if (state.userPosts) {
          state.userPosts = state.userPosts.filter(
            (post) => post?.id !== action.payload?.id,
          );
        }

        // SINGLE POST
        if (state.post) {
          state.post = {};
        }
      });
  },
});

export default postsSlice.reducer;
